import React, { useContext, useEffect } from 'react';
import MessageInfo from '../../common/MessageInfo';
import { getLabel } from '../../data/labels';
import { UserContext } from '../betslip/UserConf';
import { getStreamingBalanceLimit } from './streamingUtils';

function GeniusStreaming(props) {
	const userContext = useContext(UserContext);
	const user = userContext.getUser();
	const balanceLimit =  getStreamingBalanceLimit();
	const isBalanceLimited = balanceLimit >0 && balanceLimit > user.balance;
    const fixtureId = props.fid;
	const sourceId = props.gci;
    const playerContainerElement = "container-player";
	const playerScriptElement = "script-player";
    // TODO: nel caso spostare questa url sul db
	const urlScript = "https://drop-and-play.betstream.betgenius.com/widgetLoader?containerId=" + playerContainerElement + "&source=" + sourceId + "&fixtureId=" + fixtureId;

	var loadScript = function (src) {
		var frame = document.querySelector('.genius-iframe-live-streaming');
		var script = document.createElement('script');

		if(frame && frame.contentDocument.getElementById(playerScriptElement)){
			frame.contentDocument.getElementById(playerScriptElement).remove();
		}

		if(frame && frame.contentDocument.getElementById(playerContainerElement)){
			frame.contentDocument.getElementById(playerContainerElement).remove();
		}

		var container =  document.createElement('div');
		script.id = playerScriptElement;
		script.async = false;
		script.src = src;
		container.setAttribute("id",playerContainerElement);
		if((frame || null) !== null){
			frame.contentDocument.head.appendChild(script);
			frame.contentDocument.body.appendChild(container)
		}
		
	};

	useEffect(() => {
        loadScript(urlScript);
    }, [fixtureId]);
    
    return (
		<>
		{user.logged?
			(!isBalanceLimited?
				<iframe title="bet-genius-live-stream" scrolling="yes" className={"genius-iframe-live-streaming"}></iframe>
			 :
			 <MessageInfo message={getLabel('live_page.stream_widget.insufficient_balance')} />
			)
		:
			<MessageInfo message={getLabel('live_page.stream_widget.must_login')} />
		}
		</>
    );
}

export default GeniusStreaming;